import { Info } from 'lucide-react';
import Tooltip from '../Tooltip';
import type { AiAutoFilterItem } from './types';

const FilterList = ({ items }: { items: AiAutoFilterItem[] }) => {
  if (items.length === 0) {
    return <p className="text-xs text-gray-400">None</p>;
  }

  return (
    <ul className="space-y-2.5">
      {items.map((item) => (
        <li key={item.key} className="text-sm text-gray-600">
          <div className="flex items-center gap-1 text-xs text-gray-400">
            {item.label}
            <Tooltip content={item.description}>
              <Info className="w-3 h-3 cursor-help" />
            </Tooltip>
          </div>
          <div className="space-y-0.5">
            {item.values.map((value) => (
              <div key={value} className="break-words">
                {value}
              </div>
            ))}
          </div>
        </li>
      ))}
    </ul>
  );
};

const AiAutoFiltersPanel = ({
  appliedFilters,
  unappliedDetections,
}: {
  appliedFilters: AiAutoFilterItem[];
  unappliedDetections: AiAutoFilterItem[];
}) => (
  <div className="space-y-4">
    <section className="space-y-2">
      <h3 className="text-xs font-medium text-gray-500">Applied</h3>
      <FilterList items={appliedFilters} />
    </section>

    <section className="space-y-2 border-t border-gray-100 pt-4">
      <h3 className="text-xs font-medium text-gray-500">
        Not applied
      </h3>
      <FilterList items={unappliedDetections} />
    </section>
  </div>
);

export default AiAutoFiltersPanel;
